import { Currency } from '../../court-pricing/dto/court-pricing-rule.dto';
import { CourtDto } from '../../court/dto/court.dto';
import { UserDto } from '../../user/dto/user.dto';
import { CoachDto } from './coach.dto';

export enum CoachingSessionStatus {
  UPCOMING = 'UPCOMING',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
}

export type CoachingSessionDto = {
  id: string;
  coach: CoachDto;
  court?: CourtDto;
  user: UserDto;
  startTime: string;
  endTime: string;
  numberOfPlayers: number;
  status: CoachingSessionStatus;
  canceledByAdmin: boolean;
};

export type CoachingSessionPricingRuleDto = {
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  price: number;
  currency: Currency;
  courtId: number;
  id: string;
};

export type SetCoachingSessionPricingRulesDto = Pick<
  CoachingSessionPricingRuleDto,
  'courtId' | 'dayOfWeek' | 'startTime' | 'endTime' | 'price' | 'currency'
>[];
